import config from "../config/config";
import { searchWithTopicIdQuery } from "../openSearchQueries";
import axios from "axios";

export const getSpecialtyInAutoSuggest = async (suggestions) => {
  let autoSuggestWithSpecialtyArray = [];
  let suggestionIDs = [];
  suggestions.forEach((suggest) => {
    autoSuggestWithSpecialtyArray.push({
      id: suggest._id,
      suggestion: suggest?._source?.topic_title,
    });
    suggestionIDs.push(suggest._id);
  });
  const baseURL = `${config.BASE_URL}search`;
  let response = await axios.post(
    baseURL,
    searchWithTopicIdQuery(suggestionIDs)
  );

  let csArray = response?.data?.hits?.hits;
  let arrayWithSpecialty = [];
  autoSuggestWithSpecialtyArray.forEach((arr) => {
    const matchId = csArray.find((i) => arr.id === i._id);
    let spc = matchId?._source?.speciality;
    if (!(spc && spc.length !== 0)) spc = ["undefined"];

    arrayWithSpecialty.push({ ...arr, spc: spc });
  });
  return arrayWithSpecialty;
};
